import API from './API'

export default class Authentication extends API {
    static login(email: string, password: string) {
        return API.baseRequest("POST", "login/", {
            email: email,
            password: password
        })
    }

    static logout() {
        return API.baseRequest("POST", "logout/", {})
    }
}